import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=0fdf869f&"
import script from "./banner.vue?vue&type=script&lang=ts&"
export * from "./banner.vue?vue&type=script&lang=ts&"
import style0 from "./banner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports